import Icon from '../Icon';
import type { LucideIconData, LucideIconNode, LucideProps } from '../types';

export const __iconData: LucideIconData = {
  name: 'message-circle-dashed-check',
  size: 24,
  node: [
    ['path', { d: 'M10.1 2.182a10 10 0 013.8 0', key: 'upsxbf' }],
    ['path', { d: 'M13.9 21.818a10 10 0 01-3.8 0', key: 'ms125y' }],
    ['path', { d: 'M17.609 3.72a10 10 0 012.69 2.7', key: '1jzhoq' }],
    ['path', { d: 'M2.182 13.9a10 10 0 010-3.8', key: '68e3e5' }],
    ['path', { d: 'M20.28 17.61a10 10 0 01-2.7 2.69', key: '1m37bo' }],
    ['path', { d: 'M21.818 10.1a10 10 0 010 3.8', key: 'w6g6ls' }],
    ['path', { d: 'M3.721 6.391a10 10 0 012.7-2.69', key: 'sn8908' }],
    ['path', { d: 'm6.163 21.117-2.906.85a1 1 0 01-1.236-1.169l.965-2.98', key: '7908cd' }],
    ['path', { d: 'm16 9-5.5 5.5L8 12', key: 'xofnsj' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name MessageCircleDashedCheck
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAuMSAyLjE4MmExMCAxMCAwIDAxMy44IDAiIC8+CiAgPHBhdGggZD0iTTEzLjkgMjEuODE4YTEwIDEwIDAgMDEtMy44IDAiIC8+CiAgPHBhdGggZD0iTTE3LjYwOSAzLjcyYTEwIDEwIDAgMDEyLjY5IDIuNyIgLz4KICA8cGF0aCBkPSJNMi4xODIgMTMuOWExMCAxMCAwIDAxMC0zLjgiIC8+CiAgPHBhdGggZD0iTTIwLjI4IDE3LjYxYTEwIDEwIDAgMDEtMi43IDIuNjkiIC8+CiAgPHBhdGggZD0iTTIxLjgxOCAxMC4xYTEwIDEwIDAgMDEwIDMuOCIgLz4KICA8cGF0aCBkPSJNMy43MjEgNi4zOTFhMTAgMTAgMCAwMTIuNy0yLjY5IiAvPgogIDxwYXRoIGQ9Im02LjE2MyAyMS4xMTctMi45MDYuODVhMSAxIDAgMDEtMS4yMzYtMS4xNjlsLjk2NS0yLjk4IiAvPgogIDxwYXRoIGQ9Im0xNiA5LTUuNSA1LjVMOCAxMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/message-circle-dashed-check
 * @see https://lucide.dev/guide/packages/lucide-solid - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const MessageCircleDashedCheck = (props: LucideProps) => <Icon {...props} icon={__iconData} />;

export default MessageCircleDashedCheck;
